exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-alert-navigator-label{padding-right:16px}", ""]);

// exports
exports.locals = {
	"alertNavigatorLabelClassName": "\"ba-alert-navigator-label\""
};